<template>
    <div
        v-if="overlay_active"
        id="loading-overlay"
        class="center-content"
        :style="opacity"
    >
        <LoadAnimation />
    </div>
</template>

<style scoped>
#loading-overlay {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition:
        opacity 0.2s,
        visibility 0.2s;
    z-index: 999;
    user-select: none;
    background: rgba(0, 0, 0, 0.2);
    animation: fade 1 linear;
}

.center-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
}
</style>

<script>
import LoadAnimation from "@components/LoadAnimation.vue";
import eventbus from "@eventbus";

export default {
    name: "LoadScreen",
    components: { LoadAnimation },
    data() {
        return {
            overlay_active: false,
            overriden: false,
            shown: false,
        };
    },
    computed: {
        opacity() {
            if (this.shown) {
                return "opacity: 1;";
            }

            return "opacity: 0;";
        },
    },
    mounted() {
        eventbus.on("loading", this.show);
        eventbus.on("loading-override", this.override);
    },
    unmounted() {
        eventbus.off("loading", this.show);
        eventbus.off("loading-override", this.override);
    },
    methods: {
        override(val) {
            this.overriden = val;
            this.show(val);
        },
        show(val) {
            const that = this;
            this.shown = val;

            if (val) {
                this.overlay_active = val;
                return;
            }

            if (this.overriden) {
                return;
            }

            setTimeout(function () {
                that.overlay_active = val;
            }, 500);
        },
    },
};
</script>
